import axios from 'axios'
import {
  setFormValues,
  setFilterValues,
  toggleFilterValues,
} from '../../modules/mutations.js'

export const companiesSearchAttributes = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    formValues: {},
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
      state.loadError = false
    },
    readSearchAttributesSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    readSearchAttributesFailure(state) {
      state.loading = false
      state.loadError = true
    },
    setFormValues,
    setFilterValues,
    toggleFilterValues,
  },
  actions: {
    readSearchAttributes({ commit }, companyUuid) {
      commit('prepareConnect')
      return axios
        .get('/api/companies/' + companyUuid + '/search_attributes.json')
        .then(res => {
          commit('readSearchAttributesSuccess', res.data.data.attributes)
        })
        .catch(err => {
          commit('readSearchAttributesFailure', err)
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    }
  }
}
